import { Record, Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { anonRecord_type, obj_type, record_type, string_type, option_type, bool_type, array_type, int32_type, union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { CustomerContact, CustomerContactForm_$reflection, CustomerContactForm, CustomerContact_$reflection, CustomerInfo, GenericResponse_$reflection, AccountReplaceForm_$reflection, AccountReplaceForm, Account_$reflection, AccountAssignForm_$reflection, AccountAssignForm, CustomerGroup, CustomerInfo_$reflection } from "../Shared/ApiDataTypes.js";
import { setQuery, removeQuery, sortFn, getUrlAsPath } from "../Utils.js";
import { value as value_189, unwrap, some, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { tryExactlyOne, pick, collect, sortBy, append as append_1, map as map_2, contains as contains_1, choose } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { Result_MapError, FSharpResult$2, Result_ToOption } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { strIContains, Localization_Language, Result_catch } from "../Shared/Shared.js";
import { parse } from "../fable_modules/fable-library-js.4.24.0/Int32.js";
import { join, printf, toText, isNullOrWhiteSpace, split } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Tab, Tabs, TablePagination, TableBody, TableHead, TableRow, Table, TableContainer, Switch, Typography, TableSortLabel, TableCell, MenuItem, Menu, IconButton, Chip, TextField, Checkbox, FormControlLabel, DialogContentText, DialogActions, Button, DialogContent, DialogTitle, Dialog } from "@mui/material";
import { UserSearchTable } from "../Components/UserSearch.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { testRedirect, extraCoders, corsProps } from "../Promises.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { tail, head, isEmpty, singleton as singleton_1, item as item_3, length, cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { int32ToString, comparePrimitives, equals, numberHash, createObj, uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { onPageChange, disabledTooltip, SnackError, wrapTooltip, loadingIndicatorSmall, errorBanner } from "../ViewHelpers.js";
import { empty as empty_1, map as map_1, append, singleton, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import SyncAlt from "@mui/icons-material/SyncAlt";
import Search from "@mui/icons-material/Search";
import { useEffectOnce } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { Customer_fetchMarketCategories } from "../Promises.js";
import { API_Customer_Contact } from "../Shared/Urls.js";
import CloudUpload from "@mui/icons-material/CloudUpload";
import { rangeDouble } from "../fable_modules/fable-library-js.4.24.0/Range.js";
import Add from "@mui/icons-material/Add";
import { Components_CustomerGroupSelect_Z6A6DEF5D, Components_CustomerGroupSelect_Z10B6457D } from "../Components/CustomerGroupSelect.js";
import Delete from "@mui/icons-material/Delete";
import { hierarchyContext, Message as Message_1, dispatchContext } from "../CompanyHierarchyContext.js";
import { Array_distinctBy } from "../fable_modules/fable-library-js.4.24.0/Seq2.js";
import Remove from "@mui/icons-material/Remove";
import CheckCircle from "@mui/icons-material/CheckCircle";
import RemoveCircle from "@mui/icons-material/RemoveCircle";
import { Components_Searchbar_25F45B5E } from "../Components/Searchbar.js";
import { Components_Button_Z1043B8E } from "../Components/Button.js";
import PersonAddOutlined from "@mui/icons-material/PersonAddOutlined";
import AddOutlined from "@mui/icons-material/AddOutlined";
import Edit from "@mui/icons-material/Edit";
import { RouterModule_nav, RouterModule_urlSegments } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { CustomerGroupAdmin } from "./CustomerGroup.js";

class PreMultiForm extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Responsible", "SwapResponsible", "ServiceLead", "SwapServiceLead", "MarketCategory"];
    }
}

function PreMultiForm_$reflection() {
    return union_type("Kundeweb.Admin.Customers.PreMultiForm", [], PreMultiForm, () => [[], [], [], [], []]);
}

class Model extends Record {
    constructor(SelectedGroupIds, AddForm, EditForm, ResponsibleForm, RemoveResponsibleForm, ResponsibleGroupForm, ResponsibleReplaceForm, ServiceLeadForm, RemoveServiceLeadForm, ServiceLeadGroupForm, ServiceLeadReplaceForm, MultiCategoryForm, PreForm, ErrorMsg) {
        super();
        this.SelectedGroupIds = SelectedGroupIds;
        this.AddForm = AddForm;
        this.EditForm = EditForm;
        this.ResponsibleForm = ResponsibleForm;
        this.RemoveResponsibleForm = RemoveResponsibleForm;
        this.ResponsibleGroupForm = ResponsibleGroupForm;
        this.ResponsibleReplaceForm = ResponsibleReplaceForm;
        this.ServiceLeadForm = ServiceLeadForm;
        this.RemoveServiceLeadForm = RemoveServiceLeadForm;
        this.ServiceLeadGroupForm = ServiceLeadGroupForm;
        this.ServiceLeadReplaceForm = ServiceLeadReplaceForm;
        this.MultiCategoryForm = MultiCategoryForm;
        this.PreForm = PreForm;
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("Kundeweb.Admin.Customers.Model", [], Model, () => [["SelectedGroupIds", array_type(int32_type)], ["AddForm", bool_type], ["EditForm", option_type(CustomerInfo_$reflection())], ["ResponsibleForm", option_type(int32_type)], ["RemoveResponsibleForm", option_type(int32_type)], ["ResponsibleGroupForm", bool_type], ["ResponsibleReplaceForm", bool_type], ["ServiceLeadForm", option_type(int32_type)], ["RemoveServiceLeadForm", option_type(int32_type)], ["ServiceLeadGroupForm", bool_type], ["ServiceLeadReplaceForm", bool_type], ["MultiCategoryForm", bool_type], ["PreForm", option_type(PreMultiForm_$reflection())], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetGroupIds", "SetPreForm", "ToggleAdd", "ToggleEdit", "ToggleMultiCategoryForm", "ToggleRemoveResponsibleForm", "ToggleRemoveServiceLeadForm", "ToggleResponsibleForm", "ToggleResponsibleGroupForm", "ToggleResponsibleReplaceForm", "ToggleServiceLeadForm", "ToggleServiceLeadGroupForm", "ToggleServiceLeadReplaceForm", "DismissError"];
    }
}

function Message_$reflection() {
    return union_type("Kundeweb.Admin.Customers.Message", [], Message, () => [[["Item", array_type(int32_type)]], [["Item", option_type(PreMultiForm_$reflection())]], [["Item", bool_type]], [["Item", option_type(CustomerInfo_$reflection())]], [["Item", bool_type]], [["Item", option_type(int32_type)]], [["Item", option_type(int32_type)]], [["Item", option_type(int32_type)]], [["Item", bool_type]], [["Item", bool_type]], [["Item", option_type(int32_type)]], [["Item", bool_type]], [["Item", bool_type]], []]);
}

function init() {
    const url = getUrlAsPath();
    return new Model(defaultArg(map((str) => choose((arg) => Result_ToOption(Result_catch((value) => parse(value, 511, false, 32), arg)), split(str, [","], undefined, 0), Int32Array), url.searchParams.get("groups")), new Int32Array(0)), false, undefined, undefined, undefined, false, false, undefined, undefined, false, false, false, undefined, undefined);
}

function update(model, msg) {
    switch (msg.tag) {
        case 2:
            return new Model(model.SelectedGroupIds, msg.fields[0], model.EditForm, model.ResponsibleForm, model.RemoveResponsibleForm, model.ResponsibleGroupForm, model.ResponsibleReplaceForm, model.ServiceLeadForm, model.RemoveServiceLeadForm, model.ServiceLeadGroupForm, model.ServiceLeadReplaceForm, model.MultiCategoryForm, model.PreForm, model.ErrorMsg);
        case 3:
            return new Model(model.SelectedGroupIds, model.AddForm, msg.fields[0], model.ResponsibleForm, model.RemoveResponsibleForm, model.ResponsibleGroupForm, model.ResponsibleReplaceForm, model.ServiceLeadForm, model.RemoveServiceLeadForm, model.ServiceLeadGroupForm, model.ServiceLeadReplaceForm, model.MultiCategoryForm, model.PreForm, model.ErrorMsg);
        case 7:
            return new Model(model.SelectedGroupIds, model.AddForm, model.EditForm, msg.fields[0], model.RemoveResponsibleForm, model.ResponsibleGroupForm, model.ResponsibleReplaceForm, model.ServiceLeadForm, model.RemoveServiceLeadForm, model.ServiceLeadGroupForm, model.ServiceLeadReplaceForm, model.MultiCategoryForm, model.PreForm, model.ErrorMsg);
        case 5:
            return new Model(model.SelectedGroupIds, model.AddForm, model.EditForm, model.ResponsibleForm, msg.fields[0], model.ResponsibleGroupForm, model.ResponsibleReplaceForm, model.ServiceLeadForm, model.RemoveServiceLeadForm, model.ServiceLeadGroupForm, model.ServiceLeadReplaceForm, model.MultiCategoryForm, model.PreForm, model.ErrorMsg);
        case 8:
            return new Model(model.SelectedGroupIds, model.AddForm, model.EditForm, model.ResponsibleForm, model.RemoveResponsibleForm, msg.fields[0], model.ResponsibleReplaceForm, model.ServiceLeadForm, model.RemoveServiceLeadForm, model.ServiceLeadGroupForm, model.ServiceLeadReplaceForm, model.MultiCategoryForm, undefined, model.ErrorMsg);
        case 9:
            return new Model(model.SelectedGroupIds, model.AddForm, model.EditForm, model.ResponsibleForm, model.RemoveResponsibleForm, model.ResponsibleGroupForm, msg.fields[0], model.ServiceLeadForm, model.RemoveServiceLeadForm, model.ServiceLeadGroupForm, model.ServiceLeadReplaceForm, model.MultiCategoryForm, undefined, model.ErrorMsg);
        case 10:
            return new Model(model.SelectedGroupIds, model.AddForm, model.EditForm, model.ResponsibleForm, model.RemoveResponsibleForm, model.ResponsibleGroupForm, model.ResponsibleReplaceForm, msg.fields[0], model.RemoveServiceLeadForm, model.ServiceLeadGroupForm, model.ServiceLeadReplaceForm, model.MultiCategoryForm, model.PreForm, model.ErrorMsg);
        case 6:
            return new Model(model.SelectedGroupIds, model.AddForm, model.EditForm, model.ResponsibleForm, model.RemoveResponsibleForm, model.ResponsibleGroupForm, model.ResponsibleReplaceForm, model.ServiceLeadForm, msg.fields[0], model.ServiceLeadGroupForm, model.ServiceLeadReplaceForm, model.MultiCategoryForm, model.PreForm, model.ErrorMsg);
        case 11:
            return new Model(model.SelectedGroupIds, model.AddForm, model.EditForm, model.ResponsibleForm, model.RemoveResponsibleForm, model.ResponsibleGroupForm, model.ResponsibleReplaceForm, model.ServiceLeadForm, model.RemoveServiceLeadForm, msg.fields[0], model.ServiceLeadReplaceForm, model.MultiCategoryForm, undefined, model.ErrorMsg);
        case 12:
            return new Model(model.SelectedGroupIds, model.AddForm, model.EditForm, model.ResponsibleForm, model.RemoveResponsibleForm, model.ResponsibleGroupForm, model.ResponsibleReplaceForm, model.ServiceLeadForm, model.RemoveServiceLeadForm, model.ServiceLeadGroupForm, msg.fields[0], model.MultiCategoryForm, undefined, model.ErrorMsg);
        case 4:
            return new Model(model.SelectedGroupIds, model.AddForm, model.EditForm, model.ResponsibleForm, model.RemoveResponsibleForm, model.ResponsibleGroupForm, model.ResponsibleReplaceForm, model.ServiceLeadForm, model.RemoveServiceLeadForm, model.ServiceLeadGroupForm, model.ServiceLeadReplaceForm, msg.fields[0], undefined, model.ErrorMsg);
        case 1:
            return new Model(model.SelectedGroupIds, model.AddForm, model.EditForm, model.ResponsibleForm, model.RemoveResponsibleForm, model.ResponsibleGroupForm, model.ResponsibleReplaceForm, model.ServiceLeadForm, model.RemoveServiceLeadForm, model.ServiceLeadGroupForm, model.ServiceLeadReplaceForm, model.MultiCategoryForm, msg.fields[0], model.ErrorMsg);
        case 13:
            return new Model(model.SelectedGroupIds, model.AddForm, model.EditForm, model.ResponsibleForm, model.RemoveResponsibleForm, model.ResponsibleGroupForm, model.ResponsibleReplaceForm, model.ServiceLeadForm, model.RemoveServiceLeadForm, model.ServiceLeadGroupForm, model.ServiceLeadReplaceForm, model.MultiCategoryForm, model.PreForm, undefined);
        default:
            return new Model(msg.fields[0], model.AddForm, model.EditForm, model.ResponsibleForm, model.RemoveResponsibleForm, model.ResponsibleGroupForm, model.ResponsibleReplaceForm, model.ServiceLeadForm, model.RemoveServiceLeadForm, model.ServiceLeadGroupForm, model.ServiceLeadReplaceForm, model.MultiCategoryForm, model.PreForm, model.ErrorMsg);
    }
}

class AssignTarget extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Responsible", "GroupResponsible", "ServiceLead", "GroupServiceLead"];
    }
}

function AssignTarget_$reflection() {
    return union_type("Kundeweb.Admin.Customers.AssignTarget", [], AssignTarget, () => [[], [], [], []]);
}

function AssignTarget__ToLocalizedAssignTitle_4E60E31B(this$, locale) {
    switch (this$.tag) {
        case 2:
        case 3:
            return locale.t("CustomerAdmin.AssignServiceLead");
        default:
            return locale.t("CustomerAdmin.AssignResponsible");
    }
}

function AssignTarget__ToLocalizedRevokeTitle_4E60E31B(this$, locale) {
    switch (this$.tag) {
        case 2:
        case 3:
            return locale.t("CustomerAdmin.RevokeServiceLead");
        default:
            return locale.t("CustomerAdmin.RevokeResponsible");
    }
}

function AssignTarget__ToLocalizedRevoke_4E60E31B(this$, locale) {
    switch (this$.tag) {
        case 2:
        case 3:
            return locale.t("CustomerAdmin.ConfirmRevokeServiceLead");
        default:
            return locale.t("CustomerAdmin.ConfirmRevokeResponsible");
    }
}

function AssignTarget__ToLocalizedReplaceTitle_4E60E31B(this$, locale) {
    switch (this$.tag) {
        case 2:
        case 3:
            return locale.t("CustomerAdmin.ReplaceServiceLead");
        default:
            return locale.t("CustomerAdmin.ReplaceResponsible");
    }
}

function AssignTarget__ToUrl(this$) {
    switch (this$.tag) {
        case 1:
            return "/api/customer/group-responsible";
        case 2:
            return "/api/customer/service-lead";
        case 3:
            return "/api/customer/group-service-lead";
        default:
            return "/api/customer/responsible";
    }
}

function AssignTarget__ToReplaceUrl(this$) {
    switch (this$.tag) {
        case 2:
        case 3:
            return "/api/customer/replace-service-lead";
        default:
            return "/api/customer/replace-responsible";
    }
}

function groupWithoutMembers(group) {
    return new CustomerGroup(group.Id, group.Name, group.Enabled, group.IsMain, group.IsPtg, group.Company);
}

function AssignForm(assignFormInputProps) {
    let elements_2, children, children_1;
    const onClose = assignFormInputProps.onClose;
    const target = assignFormInputProps.target;
    const targetId = assignFormInputProps.targetId;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setProcessing = patternInput[1];
    const processing = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setErrMsg = patternInput_1[1];
    return MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_4, v) => {
        onClose(undefined);
    }], ["PaperProps", {
        style: {
            width: 75 + "vw",
            maxWidth: 600,
        },
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", AssignTarget__ToLocalizedAssignTitle_4E60E31B(target, ctx.Locale)]]), (children = ofArray([createElement(UserSearchTable, {
        ptgOnly: true,
        exclude: new Int32Array([]),
        onSelect: (a_1) => {
            const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let body, decoder, data_1, caseStrategy_3, extra_3;
                if (!processing) {
                    const url = AssignTarget__ToUrl(target);
                    const req = new AccountAssignForm(a_1.AccountId, targetId);
                    return ((body = Auto_generateBoxedEncoder_437914C6(AccountAssignForm_$reflection(), undefined, undefined, undefined)(req), (decoder = Auto_generateBoxedDecoder_Z6670B51(Account_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
                        let properties_2;
                        try {
                            const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                            const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(url, properties_3).then((_arg) => {
                                let response_1, decoder_1_1;
                                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(Account_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                                    let matchValue;
                                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                            }))));
                            return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                        }
                        catch (exn) {
                            return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                        }
                    })())))))).then((_arg_2) => {
                        const res = _arg_2;
                        setProcessing(true);
                        if (res.tag === 1) {
                            const err = res.fields[0];
                            setProcessing(false);
                            setErrMsg((err.tag === 2) ? (((err.fields[0].status) === 401) ? ctx.Locale.t("CustomerAdmin.UnauthorizedAssign") : (((err.fields[0].status) === 404) ? ctx.Locale.t("UserAdmin.CustomerOrUserNotFound") : (((err.fields[0].status) === 409) ? ctx.Locale.t("CustomerAdmin.AlreadyAssigned") : ctx.Locale.t("CustomerAdmin.AssignFailed")))) : ctx.Locale.t("CustomerAdmin.AssignFailed"));
                            return Promise.resolve();
                        }
                        else {
                            onClose(res.fields[0]);
                            return Promise.resolve();
                        }
                    });
                }
                else {
                    return Promise.resolve();
                }
            }));
            pr_1.then();
        },
    }), errorBanner(patternInput_1[0], () => {
        setErrMsg(undefined);
    })]), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_1 = toList(delay(() => (processing ? singleton(loadingIndicatorSmall()) : singleton(MuiHelpers_createElement(Button, [["variant", "outlined"], ["size", "small"], ["color", "primary"], ["children", ctx.Locale.t("Cancel")], ["onClick", (_arg_6) => {
        onClose(undefined);
    }]]))))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_1))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

function ReplaceForm(replaceFormInputProps) {
    let elements_2, children_4, children_5;
    const onClose = replaceFormInputProps.onClose;
    const target = replaceFormInputProps.target;
    const groupId = replaceFormInputProps.groupId;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setProcessing = patternInput[1];
    const processing = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setErrMsg = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const infoHolder = (children) => createElement("div", {
        style: {
            display: "flex",
            alignItems: "center",
            gap: 5 + "px ",
            marginBottom: 10,
        },
        children: reactApi.Children.toArray(Array.from(children)),
    });
    return MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_4, v) => {
        onClose(undefined);
    }], ["PaperProps", {
        style: {
            width: 75 + "vw",
            maxWidth: 600,
        },
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", AssignTarget__ToLocalizedReplaceTitle_4E60E31B(target, ctx.Locale)]]), (children_4 = toList(delay(() => {
        let props_3;
        return append(singleton(infoHolder([(props_3 = {}, react.createElement(InfoOutlined, props_3)), createElement("span", {
            children: [ctx.Locale.t("CustomerAdmin.ReplaceDescription")],
        })])), delay(() => {
            let matchValue_1, r_1, props_10, props_6;
            return append((matchValue_1 = patternInput_2[0], (matchValue_1 != null) ? ((r_1 = matchValue_1, append(singleton(infoHolder([(props_10 = {}, react.createElement(SyncAlt, props_10)), createElement("span", {
                children: [r_1.Email],
            })])), delay(() => {
                let elems_2;
                return singleton(createElement("div", createObj(ofArray([["key", "select-assign"], (elems_2 = [createElement(UserSearchTable, {
                    ptgOnly: true,
                    exclude: new Int32Array([r_1.AccountId]),
                    onSelect: (a_1) => {
                        if (!processing) {
                            const r = r_1;
                            const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                                let body, decoder, data_1, caseStrategy_3, extra_3;
                                setProcessing(true);
                                const req = new AccountReplaceForm(r.AccountId, a_1.AccountId, groupId);
                                const requestPath = AssignTarget__ToReplaceUrl(target);
                                return ((body = Auto_generateBoxedEncoder_437914C6(AccountReplaceForm_$reflection(), undefined, undefined, undefined)(req), (decoder = Auto_generateBoxedDecoder_Z6670B51(Account_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
                                    let properties_2;
                                    try {
                                        const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                                        const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(requestPath, properties_3).then((_arg) => {
                                            let response_1, decoder_1_1;
                                            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(Account_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                                                let matchValue;
                                                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                                            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                                        }))));
                                        return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                                    }
                                    catch (exn) {
                                        return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                                    }
                                })())))))).then((_arg_2) => {
                                    const res = _arg_2;
                                    if (res.tag === 1) {
                                        const err = res.fields[0];
                                        setProcessing(false);
                                        setErrMsg((err.tag === 2) ? (((err.fields[0].status) === 401) ? ctx.Locale.t("CustomerAdmin.UnauthorizedAssign") : (((err.fields[0].status) === 404) ? ctx.Locale.t("CustomerAdmin.UpdateNotFound") : ctx.Locale.t("CustomerAdmin.AssignFailed"))) : ctx.Locale.t("CustomerAdmin.AssignFailed"));
                                        return Promise.resolve();
                                    }
                                    else {
                                        onClose([r, res.fields[0]]);
                                        return Promise.resolve();
                                    }
                                });
                            }));
                            pr_1.then();
                        }
                    },
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
            })))) : append(singleton(infoHolder([(props_6 = {}, react.createElement(Search, props_6)), createElement("span", {
                children: [ctx.Locale.t("CustomerAdmin.ChooseReplace")],
            })])), delay(() => {
                let elems_1;
                return singleton(createElement("div", createObj(ofArray([["key", "select-replace"], (elems_1 = [createElement(UserSearchTable, {
                    ptgOnly: true,
                    exclude: new Int32Array([]),
                    onSelect: (arg_3) => {
                        patternInput_2[1](arg_3);
                    },
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
            }))), delay(() => singleton(errorBanner(patternInput_1[0], () => {
                setErrMsg(undefined);
            }))));
        }));
    })), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children_4))]])), (children_5 = toList(delay(() => (processing ? singleton(loadingIndicatorSmall()) : singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["color", "primary"], ["onClick", (_arg_6) => {
        onClose(undefined);
    }], ["children", ctx.Locale.t("Cancel")]]))))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_5))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

function RevokeForm(revokeFormInputProps) {
    let elements_2, children, children_1;
    const onClose = revokeFormInputProps.onClose;
    const target = revokeFormInputProps.target;
    const customerId = revokeFormInputProps.customerId;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setProcessing = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const setErrMsg = patternInput_1[1];
    return MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_4, v) => {
        onClose(false);
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", AssignTarget__ToLocalizedRevokeTitle_4E60E31B(target, ctx.Locale)]]), (children = ofArray([MuiHelpers_createElement(DialogContentText, [["children", AssignTarget__ToLocalizedRevoke_4E60E31B(target, ctx.Locale)]]), errorBanner(patternInput_1[0], () => {
        setErrMsg(undefined);
    })]), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_1 = toList(delay(() => (patternInput[0] ? singleton(loadingIndicatorSmall()) : append(singleton(MuiHelpers_createElement(Button, [["variant", "outlined"], ["size", "small"], ["color", "primary"], ["onClick", (_arg_6) => {
        onClose(false);
    }], ["children", ctx.Locale.t("Cancel")]])), delay(() => singleton(MuiHelpers_createElement(Button, [["variant", "contained"], ["size", "small"], ["color", "primary"], ["onClick", (_arg_7) => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder, data_1, caseStrategy_2, extra_2;
            setProcessing(true);
            const requestPath = `${AssignTarget__ToUrl(target)}/${customerId}`;
            return ((decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["DELETE"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(requestPath, properties_3).then((_arg) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))).then((_arg_2) => {
                const res = _arg_2;
                if (res.tag === 1) {
                    const err = res.fields[0];
                    setProcessing(false);
                    setErrMsg((err.tag === 2) ? (((err.fields[0].status) === 401) ? ctx.Locale.t("CustomerAdmin.UnauthorizedAssign") : ctx.Locale.t("CustomerAdmin.AssignFailed")) : ctx.Locale.t("CustomerAdmin.AssignFailed"));
                    return Promise.resolve();
                }
                else {
                    const x_1 = res.fields[0];
                    if (x_1.Result === "success") {
                        onClose(true);
                        return Promise.resolve();
                    }
                    else {
                        setProcessing(false);
                        setErrMsg(x_1.Message);
                        return Promise.resolve();
                    }
                }
            });
        }));
        pr_1.then();
    }], ["children", ctx.Locale.t("Revoke")]]))))))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_1))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

function CustomerForm(customerFormInputProps) {
    let elements_3, elements_1, children_3;
    const onClose = customerFormInputProps.onClose;
    const updating = customerFormInputProps.updating;
    const groups = customerFormInputProps.groups;
    const selectedGroupIds = customerFormInputProps.selectedGroupIds;
    const isOpen = customerFormInputProps.isOpen;
    const key = customerFormInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    let patternInput;
    const initial = defaultArg(updating, new CustomerInfo(-1, 1, "", true, false, false, false, false, undefined, undefined, undefined, [], [], choose((group) => {
        if (contains_1(group.Id, selectedGroupIds, {
            Equals: (x, y) => (x === y),
            GetHashCode: numberHash,
        })) {
            return groupWithoutMembers(group);
        }
        else {
            return undefined;
        }
    }, groups)));
    patternInput = reactApi.useState(initial);
    const updateCustomer = patternInput[1];
    const customer = patternInput[0];
    const patternInput_1 = reactApi.useState(true);
    const validNumber = patternInput_1[0];
    const setValidNumber = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setErrMsg = patternInput_2[1];
    const patternInput_3 = reactApi.useState(false);
    const setProcessing = patternInput_3[1];
    const patternInput_4 = reactApi.useState([]);
    const patternInput_5 = reactApi.useState(false);
    const setCategoryMenuOpen = patternInput_5[1];
    const categoryMenuOpen = patternInput_5[0];
    const categoryAnchor = reactApi.useRef(undefined);
    const patternInput_6 = reactApi.useState(true);
    const setLoadingContact = patternInput_6[1];
    const patternInput_7 = reactApi.useState(undefined);
    const setContact = patternInput_7[1];
    useEffectOnce(() => {
        Customer_fetchMarketCategories((_arg_1) => {
            if (_arg_1.tag === 1) {
                console.error(some("[AdminCustomers] Error fetching market caterogies"), _arg_1.fields[0]);
            }
            else {
                patternInput_4[1](_arg_1.fields[0]);
            }
        });
    });
    reactApi.useEffect(() => {
        let properties_2;
        if (updating != null) {
            const u = updating;
            setLoadingContact(true);
            let pr_2;
            const url = API_Customer_Contact(u.Id);
            let pr_1;
            const decoder = Auto_generateBoxedDecoder_Z6670B51(CustomerContact_$reflection(), undefined, undefined);
            const data_1 = undefined;
            const caseStrategy_2 = undefined;
            const extra_2 = extraCoders;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(url, properties_3).then((_arg_2) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg_2, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(CustomerContact_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_3) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_3), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
            }
            catch (exn) {
                pr_1 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
            pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
            pr_2.then((res) => {
                if (res.tag === 1) {
                    const err_1 = res.fields[0];
                    let matchResult, y_2;
                    if (err_1.tag === 2) {
                        if ((err_1.fields[0].status) === 404) {
                            matchResult = 0;
                            y_2 = err_1.fields[0];
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                    switch (matchResult) {
                        case 0: {
                            setContact(undefined);
                            break;
                        }
                    }
                }
                else {
                    setContact(res.fields[0]);
                }
                setLoadingContact(false);
            });
        }
    }, []);
    const genericCheckbox = (value_12, label, onChange) => MuiHelpers_createElement(FormControlLabel, [["labelPlacement", "end"], ["label", label], ["control", MuiHelpers_createElement(Checkbox, [["checked", value_12], ["onChange", (e) => {
        onChange(e.target.checked);
    }], ["color", "primary"], ["id", `checkbox-${label}`]])]]);
    const contactUpload = () => {
        let elems, child, props_3;
        return createElement("label", createObj(ofArray([["style", {
            cursor: "pointer",
            textAlign: "center",
        }], (elems = [(child = ((props_3 = {}, react.createElement(CloudUpload, props_3))), wrapTooltip(ctx.Locale.t("Add"), child)), createElement("input", {
            type: "file",
            accept: "image/*,.pdf",
            onChange: (ev) => {
                const fileList = ev.target.files;
                if (!(fileList == null)) {
                    const x_9 = toList(delay(() => map_1((i) => fileList.item(i), rangeDouble(0, 1, fileList.length - 1))));
                    try {
                        if (length(x_9) > 0) {
                            const file = item_3(0, x_9);
                            const filename_1 = file.name;
                            const reader = new FileReader();
                            reader.addEventListener("load", (_arg_15) => {
                                const filename = filename_1;
                                const content = reader.result;
                                const pr_6 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                                    let body_7, decoder_9, data_13, caseStrategy_29, extra_29;
                                    if (updating != null) {
                                        const u_1 = updating;
                                        const req = new CustomerContactForm(u_1.Id, filename, content);
                                        return ((body_7 = Auto_generateBoxedEncoder_437914C6(CustomerContactForm_$reflection(), undefined, undefined, undefined)(req), (decoder_9 = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_13 = some(body_7), (caseStrategy_29 = undefined, (extra_29 = undefined, (() => {
                                            let properties_12;
                                            try {
                                                const properties_3_3 = Helper_withProperties(corsProps, (properties_12 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_13, empty()), 0)])]), defaultArg(map((data_1_4) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_29), unwrap(extra_29))(data_1_4))]), properties_12), data_13), properties_12)));
                                                const pr_5 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/customer/upload-contact", properties_3_3).then((_arg_9) => {
                                                    let response_7, decoder_1_4;
                                                    return ((response_7 = _arg_9, (decoder_1_4 = defaultArg(decoder_9, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_29), unwrap(extra_29))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_7.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_7.text().then((_arg_10) => {
                                                        let matchValue_3;
                                                        return Promise.resolve((matchValue_3 = fromString(uncurry2(decoder_1_4), _arg_10), (matchValue_3.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_3.fields[0]])])) : (new FSharpResult$2(0, [matchValue_3.fields[0]]))));
                                                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_7])])))).then((_arg_1_4) => (Promise.resolve(_arg_1_4)))))))));
                                                }))));
                                                return pr_5.then(void 0, ((arg_3) => (new FSharpResult$2(1, [new FetchError(3, [arg_3])]))));
                                            }
                                            catch (exn_3) {
                                                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_3])])))));
                                            }
                                        })())))))).then((_arg_11) => {
                                            const res_2 = _arg_11;
                                            if (res_2.tag === 0) {
                                                const x_6 = res_2.fields[0];
                                                if (x_6.Result === "success") {
                                                    setContact(new CustomerContact(u_1.Id, u_1.Name, filename, ""));
                                                    return Promise.resolve();
                                                }
                                                else {
                                                    setErrMsg(x_6.Message);
                                                    return Promise.resolve();
                                                }
                                            }
                                            else {
                                                return Promise.resolve();
                                            }
                                        });
                                    }
                                    else {
                                        return Promise.resolve();
                                    }
                                }));
                                pr_6.then();
                            });
                            reader.readAsDataURL(file);
                        }
                    }
                    catch (matchValue_5) {
                    }
                }
            },
            style: {
                display: "none",
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    };
    return MuiHelpers_createElement(Dialog, [["open", isOpen], ["onClose", (_arg_17, v) => {
        onClose(undefined);
    }], ["PaperProps", {
        style: {
            width: 400,
            minHeight: 300,
        },
    }], (elements_3 = [MuiHelpers_createElement(DialogTitle, [["children", (updating != null) ? ctx.Locale.t("CustomerAdmin.Update") : ctx.Locale.t("CustomerAdmin.Add")]]), MuiHelpers_createElement(DialogContent, [["sx", {
        display: "flex",
        flexDirection: "column",
        gap: 10 + "px",
    }], ["dividers", true], (elements_1 = toList(delay(() => append(singleton(MuiHelpers_createElement(TextField, [["label", ctx.Locale.t("Customer.CustomerNo")], ["value", customer.Number], ["color", "primary"], ["error", !validNumber], ["fullWidth", true], ["onChange", (e_1) => {
        const x_10 = e_1.target.value;
        try {
            const asInt = parse(x_10, 511, false, 32) | 0;
            if (asInt >= 0) {
                updateCustomer(new CustomerInfo(customer.Id, asInt, customer.Name, customer.Enabled, customer.EnableServices, customer.EnableExtra, customer.HasAgreement, customer.Favorite, customer.Memo, customer.Responsible, customer.ServiceLead, customer.Machines, customer.MarketCategories, customer.Groups));
                setValidNumber(true);
            }
            else {
                setValidNumber(false);
            }
        }
        catch (matchValue_6) {
            setValidNumber(false);
        }
    }]])), delay(() => append(singleton(MuiHelpers_createElement(TextField, [["label", ctx.Locale.t("Customer.Name")], ["value", customer.Name], ["color", "primary"], ["fullWidth", true], ["onChange", (e_2) => {
        updateCustomer(new CustomerInfo(customer.Id, customer.Number, e_2.target.value, customer.Enabled, customer.EnableServices, customer.EnableExtra, customer.HasAgreement, customer.Favorite, customer.Memo, customer.Responsible, customer.ServiceLead, customer.Machines, customer.MarketCategories, customer.Groups));
    }]])), delay(() => append(singleton(createElement("span", {
        style: {
            fontSize: 0.85 + "rem",
            fontStyle: "italic",
        },
        children: ctx.Locale.t("CustomerAdmin.MarketCategory"),
    })), delay(() => {
        let elems_2, child_1, props_12, elements;
        return append(singleton(createElement("div", createObj(ofArray([["style", {}], (elems_2 = [map_2((c_2) => MuiHelpers_createElement(Chip, [["size", "small"], ["label", equals(ctx.Language, new Localization_Language(1, [])) ? c_2.NameEn : c_2.NameNo], ["style", {
            margin: ((((((0 + "px ") + 3) + "px ") + 3) + "px ") + 0) + "px",
        }], ["onDelete", (_arg_18) => {
            updateCustomer(new CustomerInfo(customer.Id, customer.Number, customer.Name, customer.Enabled, customer.EnableServices, customer.EnableExtra, customer.HasAgreement, customer.Favorite, customer.Memo, customer.Responsible, customer.ServiceLead, customer.Machines, customer.MarketCategories.filter((c$0027) => (c_2.Id !== c$0027.Id)), customer.Groups));
        }]]), customer.MarketCategories), (child_1 = MuiHelpers_createElement(IconButton, [["size", "small"], ["children", (props_12 = {}, react.createElement(Add, props_12))], ["ref", categoryAnchor], ["onClick", (_arg_19) => {
            setCategoryMenuOpen(!categoryMenuOpen);
        }]]), wrapTooltip(ctx.Locale.t("Add"), child_1)), MuiHelpers_createElement(Menu, [["open", categoryMenuOpen], ["onClose", (_arg_21, v_1) => {
            setCategoryMenuOpen(false);
        }], ["anchorEl", () => categoryAnchor.current], (elements = [map_2((c_5) => MuiHelpers_createElement(MenuItem, [["children", equals(ctx.Language, new Localization_Language(1, [])) ? c_5.NameEn : c_5.NameNo], ["onClick", (_arg_22) => {
            updateCustomer(new CustomerInfo(customer.Id, customer.Number, customer.Name, customer.Enabled, customer.EnableServices, customer.EnableExtra, customer.HasAgreement, customer.Favorite, customer.Memo, customer.Responsible, customer.ServiceLead, customer.Machines, append_1(customer.MarketCategories, [c_5]), customer.Groups));
            setCategoryMenuOpen(false);
        }]]), sortBy((c_4) => c_4.NameNo, patternInput_4[0].filter((c_3) => !customer.MarketCategories.some((c$0027_1) => (c$0027_1.Id === c_3.Id))), {
            Compare: comparePrimitives,
        }))], ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => append(singleton(createElement("span", {
            style: {
                fontSize: 0.85 + "rem",
                fontStyle: "italic",
                marginBottom: 5,
            },
            children: ctx.Locale.t("CustomerAdmin.BelongsTo"),
        })), delay(() => append(singleton(createElement(Components_CustomerGroupSelect_Z10B6457D, {
            key: "admin-add-customer-group-select",
            $key: "admin-add-customer-group-select",
            groups: map_2(groupWithoutMembers, groups),
            onChange: (groups_1) => {
                console.debug("[CustomerForm] Updated groups this customer belongs to: %o", groups_1);
                updateCustomer(new CustomerInfo(customer.Id, customer.Number, customer.Name, customer.Enabled, customer.EnableServices, customer.EnableExtra, customer.HasAgreement, customer.Favorite, customer.Memo, customer.Responsible, customer.ServiceLead, customer.Machines, customer.MarketCategories, groups_1));
            },
            selected: map_2((_arg_23) => _arg_23.Id, customer.Groups, Int32Array),
        })), delay(() => append((updating != null) ? append(singleton(genericCheckbox(customer.Enabled, ctx.Locale.t("Active"), (x_13) => {
            updateCustomer(new CustomerInfo(customer.Id, customer.Number, customer.Name, x_13, customer.EnableServices, customer.EnableExtra, customer.HasAgreement, customer.Favorite, customer.Memo, customer.Responsible, customer.ServiceLead, customer.Machines, customer.MarketCategories, customer.Groups));
        })), delay(() => append(singleton(genericCheckbox(customer.EnableExtra, "Ekstra funksjonalitet", (x_14) => {
            updateCustomer(new CustomerInfo(customer.Id, customer.Number, customer.Name, customer.Enabled, customer.EnableServices, x_14, customer.HasAgreement, customer.Favorite, customer.Memo, customer.Responsible, customer.ServiceLead, customer.Machines, customer.MarketCategories, customer.Groups));
        })), delay(() => append(singleton(genericCheckbox(customer.EnableServices, ctx.Locale.t("Services.ServicePlan"), (x_15) => {
            updateCustomer(new CustomerInfo(customer.Id, customer.Number, customer.Name, customer.Enabled, x_15, customer.EnableExtra, customer.HasAgreement, customer.Favorite, customer.Memo, customer.Responsible, customer.ServiceLead, customer.Machines, customer.MarketCategories, customer.Groups));
        })), delay(() => {
            let elems_5;
            return singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
            }], (elems_5 = toList(delay(() => append(singleton(createElement("span", {
                style: {
                    fontSize: 0.85 + "rem",
                    fontStyle: "italic",
                    marginBottom: 5,
                },
                children: ctx.Locale.t("CustomerAdmin.ContactPoster"),
            })), delay(() => {
                let elems_4, child_4, props_23, elems_3;
                if (patternInput_6[0]) {
                    return singleton(loadingIndicatorSmall());
                }
                else {
                    const matchValue_7 = patternInput_7[0];
                    if (matchValue_7 != null) {
                        const c_6 = matchValue_7;
                        return singleton(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            alignItems: "center",
                            gap: 10 + "px ",
                            flexWrap: "wrap",
                        }], (elems_4 = [createElement("span", {
                            children: [c_6.Filename],
                        }), contactUpload(), (child_4 = MuiHelpers_createElement(IconButton, [["size", "small"], ["children", (props_23 = {}, react.createElement(Delete, props_23))], ["onClick", (_arg_24) => {
                            const pr_8 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                                let decoder_12, data_17, caseStrategy_37, extra_37;
                                if (updating != null) {
                                    const requestPath = API_Customer_Contact(updating.Id);
                                    return ((decoder_12 = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_17 = undefined, (caseStrategy_37 = undefined, (extra_37 = undefined, (() => {
                                        let properties_15;
                                        try {
                                            const properties_3_4 = Helper_withProperties(corsProps, (properties_15 = ofArray([new Types_RequestProperties(0, ["DELETE"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_17, empty()), 0)])]), defaultArg(map((data_1_5) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_37), unwrap(extra_37))(data_1_5))]), properties_15), data_17), properties_15)));
                                            const pr_7 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(requestPath, properties_3_4).then((_arg_12) => {
                                                let response_9, decoder_1_5;
                                                return ((response_9 = _arg_12, (decoder_1_5 = defaultArg(decoder_12, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_37), unwrap(extra_37))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_9.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_9.text().then((_arg_13) => {
                                                    let matchValue_4;
                                                    return Promise.resolve((matchValue_4 = fromString(uncurry2(decoder_1_5), _arg_13), (matchValue_4.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_4.fields[0]])])) : (new FSharpResult$2(0, [matchValue_4.fields[0]]))));
                                                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_9])])))).then((_arg_1_5) => (Promise.resolve(_arg_1_5)))))))));
                                            }))));
                                            return pr_7.then(void 0, ((arg_4) => (new FSharpResult$2(1, [new FetchError(3, [arg_4])]))));
                                        }
                                        catch (exn_4) {
                                            return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_4])])))));
                                        }
                                    })()))))).then((_arg_14) => {
                                        const res_3 = _arg_14;
                                        if (res_3.tag === 0) {
                                            const x_8 = res_3.fields[0];
                                            if (x_8.Result === "success") {
                                                setContact(undefined);
                                                return Promise.resolve();
                                            }
                                            else {
                                                setErrMsg(x_8.Message);
                                                return Promise.resolve();
                                            }
                                        }
                                        else {
                                            return Promise.resolve();
                                        }
                                    });
                                }
                                else {
                                    return Promise.resolve();
                                }
                            }));
                            pr_8.then();
                        }]]), wrapTooltip(ctx.Locale.t("Delete"), child_4))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                    }
                    else {
                        return singleton(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            alignItems: "center",
                            gap: 10 + "px ",
                            flexWrap: "wrap",
                        }], (elems_3 = [createElement("span", {
                            children: [ctx.Locale.t("NoSelection")],
                        }), contactUpload()], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
                    }
                }
            })))), ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
        })))))) : empty_1(), delay(() => singleton(errorBanner(patternInput_2[0], () => {
            setErrMsg(undefined);
        }))))))))));
    })))))))), ["children", reactApi.Children.toArray(Array.from(elements_1))])]), (children_3 = toList(delay(() => (patternInput_3[0] ? singleton(loadingIndicatorSmall()) : append(singleton(MuiHelpers_createElement(Button, [["size", "small"], ["color", "primary"], ["children", ctx.Locale.t("Cancel")], ["onClick", (_arg_26) => {
        onClose(undefined);
    }]])), delay(() => singleton(MuiHelpers_createElement(Button, [["size", "small"], ["color", "primary"], ["variant", "contained"], ["disabled", (customer.Name.trim().length === 0) ? true : !validNumber], ["children", (updating != null) ? ctx.Locale.t("Update") : ctx.Locale.t("Add")], ["onClick", (_arg_27) => {
        const pr_9 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let body_2, decoder_3, data_5, caseStrategy_11, extra_11, data_8, decoder_6, data_9, caseStrategy_20, extra_20;
            if (isNullOrWhiteSpace(customer.Name)) {
                console.error(some("Customer name can not be null"));
                return Promise.resolve();
            }
            else {
                setErrMsg(undefined);
                setProcessing(true);
                return ((updating == null) ? ((body_2 = Auto_generateBoxedEncoder_437914C6(CustomerInfo_$reflection(), undefined, undefined, undefined)(customer), (decoder_3 = Auto_generateBoxedDecoder_Z6670B51(CustomerInfo_$reflection(), undefined, undefined), (data_5 = some(body_2), (caseStrategy_11 = undefined, (extra_11 = undefined, (() => {
                    let properties_6;
                    try {
                        const properties_3_1 = Helper_withProperties(corsProps, (properties_6 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty()), 0)])]), defaultArg(map((data_1_2) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_11), unwrap(extra_11))(data_1_2))]), properties_6), data_5), properties_6)));
                        const pr_3 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/customer/edit", properties_3_1).then((_arg_4) => {
                            let response_3, decoder_1_2;
                            return ((response_3 = _arg_4, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(CustomerInfo_$reflection(), unwrap(caseStrategy_11), unwrap(extra_11))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_3.text().then((_arg_5) => {
                                let matchValue_1;
                                return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_2), _arg_5), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
                        }))));
                        return pr_3.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])]))));
                    }
                    catch (exn_1) {
                        return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
                    }
                })())))))) : ((data_8 = some(Auto_generateBoxedEncoder_437914C6(CustomerInfo_$reflection(), undefined, undefined, undefined)(customer)), (decoder_6 = Auto_generateBoxedDecoder_Z6670B51(CustomerInfo_$reflection(), undefined, undefined), (data_9 = data_8, (caseStrategy_20 = undefined, (extra_20 = undefined, (() => {
                    let properties_9;
                    try {
                        const properties_3_2 = Helper_withProperties(corsProps, (properties_9 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_9, empty()), 0)])]), defaultArg(map((data_1_3) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_20), unwrap(extra_20))(data_1_3))]), properties_9), data_9), properties_9)));
                        const pr_4 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/customer/edit", properties_3_2).then((_arg_6) => {
                            let response_5, decoder_1_3;
                            return ((response_5 = _arg_6, (decoder_1_3 = defaultArg(decoder_6, Auto_generateBoxedDecoderCached_Z6670B51(CustomerInfo_$reflection(), unwrap(caseStrategy_20), unwrap(extra_20))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_5.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_5.text().then((_arg_7) => {
                                let matchValue_2;
                                return Promise.resolve((matchValue_2 = fromString(uncurry2(decoder_1_3), _arg_7), (matchValue_2.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_2.fields[0]])])) : (new FSharpResult$2(0, [matchValue_2.fields[0]]))));
                            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_5])])))).then((_arg_1_3) => (Promise.resolve(_arg_1_3)))))))));
                        }))));
                        return pr_4.then(void 0, ((arg_2) => (new FSharpResult$2(1, [new FetchError(3, [arg_2])]))));
                    }
                    catch (exn_2) {
                        return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_2])])))));
                    }
                })()))))))).then((_arg_8) => {
                    let err_2;
                    const res_1 = _arg_8;
                    return ((res_1.tag === 1) ? ((err_2 = res_1.fields[0], (setErrMsg((err_2.tag === 2) ? (((err_2.fields[0].status) === 400) ? ctx.Locale.t("CustomerAdmin.InvalidNameOrNumber") : (((err_2.fields[0].status) === 404) ? ctx.Locale.t("CustomerAdmin.UpdateNotFound") : (((err_2.fields[0].status) === 409) ? ctx.Locale.t("CustomerAdmin.CustomerExists") : ((updating != null) ? ctx.Locale.t("CustomerAdmin.AddFailed") : ctx.Locale.t("CustomerAdmin.UpdateFailed"))))) : ((updating != null) ? ctx.Locale.t("CustomerAdmin.AddFailed") : ctx.Locale.t("CustomerAdmin.UpdateFailed"))), Promise.resolve()))) : ((onClose(res_1.fields[0]), Promise.resolve()))).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        setProcessing(false);
                        return Promise.resolve();
                    }));
                });
            }
        }));
        pr_9.then();
    }]]))))))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_3))]]))], ["children", reactApi.Children.toArray(Array.from(elements_3))])]);
}

function MultiAssignCategoryForm(multiAssignCategoryFormInputProps) {
    let elements_2, children, elems_1, elems, children_1;
    const onClose = multiAssignCategoryFormInputProps.onClose;
    const groupId = multiAssignCategoryFormInputProps.groupId;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(undefined);
    const categories = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const setProcessing = patternInput_1[1];
    const processing = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const setErrMsg = patternInput_2[1];
    reactApi.useEffect(() => {
        Customer_fetchMarketCategories((res) => {
            if (res.tag === 0) {
                patternInput[1](res.fields[0]);
            }
            else {
                setErrMsg(ctx.Locale.t("CustomerAdmin.CategoryFetchFailed"));
            }
        });
    }, []);
    return MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_5, v) => {
        onClose(undefined);
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", ctx.Locale.t("CustomerAdmin.AddCategoryAll")]]), (children = singleton_1(createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        gap: 10 + "px ",
    }], (elems_1 = [createElement("span", {
        children: [ctx.Locale.t("CustomerAdmin.ChooseCategory")],
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        gap: 10 + "px ",
    }], (elems = toList(delay(() => ((categories != null) ? singleton(map_2((cat) => MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["children", equals(ctx.Language, new Localization_Language(0, [])) ? cat.NameNo : cat.NameEn], ["onClick", (_arg_6) => {
        if (!processing) {
            const category = cat;
            const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let item, body, decoder, data_1, caseStrategy_3, extra_3;
                setProcessing(true);
                return ((item = {
                    CatId: category.Id,
                    GroupId: groupId,
                }, (body = Auto_generateBoxedEncoder_437914C6(anonRecord_type(["CatId", int32_type], ["GroupId", int32_type]), undefined, undefined, undefined)(item), (decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
                    let properties_2;
                    try {
                        const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                        const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/customer/assign-category-all", properties_3).then((_arg_1) => {
                            let response_1, decoder_1_1;
                            return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_2) => {
                                let matchValue;
                                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                        }))));
                        return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                    }
                    catch (exn) {
                        return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                    }
                })()))))))).then((_arg_3) => {
                    const res_1 = _arg_3;
                    if (res_1.tag === 0) {
                        const x_2 = res_1.fields[0];
                        if (x_2.Result === "success") {
                            onClose(category);
                            return Promise.resolve();
                        }
                        else {
                            setErrMsg(x_2.Message);
                            setProcessing(false);
                            return Promise.resolve();
                        }
                    }
                    else {
                        setErrMsg(ctx.Locale.t("CustomerAdmin.CategoryAssignFailed"));
                        setProcessing(false);
                        return Promise.resolve();
                    }
                });
            }));
            pr_1.then();
        }
    }]]), categories)) : singleton(loadingIndicatorSmall())))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), errorBanner(patternInput_2[0], () => {
        setErrMsg(undefined);
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_1 = toList(delay(() => (processing ? singleton(loadingIndicatorSmall()) : singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["color", "primary"], ["children", ctx.Locale.t("Cancel")], ["onClick", (_arg_8) => {
        onClose(undefined);
    }]]))))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_1))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

function preMultiWarning(locale, multiTarget, dispatch) {
    let elements_2, children, children_1;
    return MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_1, v) => {
        dispatch(new Message(1, [undefined]));
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", "!"]]), (children = singleton_1(MuiHelpers_createElement(DialogContentText, [["children", (multiTarget.tag === 2) ? locale.t("CustomerAdmin.AssigningAllWarning") : ((multiTarget.tag === 1) ? locale.t("CustomerAdmin.ReplaceAllWarning") : ((multiTarget.tag === 3) ? locale.t("CustomerAdmin.ReplaceAllWarning") : ((multiTarget.tag === 4) ? locale.t("CustomerAdmin.MarketAssignWarning") : locale.t("CustomerAdmin.AssigningAllWarning"))))]])), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_1 = ofArray([MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["color", "primary"], ["children", locale.t("Cancel")], ["onClick", (_arg_2) => {
        dispatch(new Message(1, [undefined]));
    }]]), MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["color", "primary"], ["children", locale.t("Ok")], ["onClick", (_arg_3) => {
        dispatch((multiTarget.tag === 1) ? (new Message(9, [true])) : ((multiTarget.tag === 2) ? (new Message(11, [true])) : ((multiTarget.tag === 3) ? (new Message(12, [true])) : ((multiTarget.tag === 4) ? (new Message(4, [true])) : (new Message(8, [true]))))));
    }]])]), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_1))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

function sortHeaderCell(asc, key, current, onClick, children) {
    let elements_1;
    const active = key === current;
    return MuiHelpers_createElement(TableCell, [["variant", "head"], ["size", "small"], (elements_1 = [MuiHelpers_createElement(TableSortLabel, toList(delay(() => append(singleton(["onClick", (_arg) => {
        onClick(key);
    }]), delay(() => append(asc ? singleton(["direction", "asc"]) : singleton(["direction", "desc"]), delay(() => append(singleton(["active", active]), delay(() => singleton(["children", reactApi.Children.toArray(Array.from(children))]))))))))))], ["children", reactApi.Children.toArray(Array.from(elements_1))])]);
}

function CustomerAdmin(customerAdminInputProps) {
    const groupsWithMembers = customerAdminInputProps.groupsWithMembers;
    const ctx = reactApi.useContext(ctx_1);
    const hierarchyDispatch = reactApi.useContext(dispatchContext);
    let patternInput;
    const arg_1 = init();
    patternInput = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(true);
    const showInactive = patternInput_1[0];
    const patternInput_2 = reactApi.useState("");
    const searchTerm = patternInput_2[0];
    const patternInput_3 = reactApi.useState(true);
    const asc = patternInput_3[0];
    const patternInput_4 = reactApi.useState("Name");
    const sortKey = patternInput_4[0];
    const patternInput_5 = reactApi.useState(0);
    const setPage = patternInput_5[1];
    const page = patternInput_5[0] | 0;
    const patternInput_6 = reactApi.useState(10);
    const rowsPerPage = patternInput_6[0] | 0;
    const customers = map_2((customer) => (new CustomerInfo(customer.Id, customer.Number, customer.Name, customer.Enabled, customer.EnableServices, customer.EnableExtra, customer.HasAgreement, customer.Favorite, customer.Memo, customer.Responsible, customer.ServiceLead, customer.Machines, customer.MarketCategories, choose((group_1) => {
        if (group_1.Customers.some((existing) => (existing.Id === customer.Id))) {
            return groupWithoutMembers(group_1);
        }
        else {
            return undefined;
        }
    }, groupsWithMembers))), Array_distinctBy((_arg) => _arg.Id, collect((group) => group.Customers, groupsWithMembers), {
        Equals: (x, y) => (x === y),
        GetHashCode: numberHash,
    }));
    const sorted = sortFn(asc, sortKey)(customers.filter((customer_1) => {
        if (((model_1.SelectedGroupIds.length === 0) ? true : model_1.SelectedGroupIds.some((groupId) => customer_1.Groups.some((customerGroup) => (customerGroup.Id === groupId)))) && (showInactive ? true : customer_1.Enabled)) {
            const noTerm = isNullOrWhiteSpace(searchTerm);
            const contains = (str_1) => strIContains(searchTerm, str_1);
            const customerResp = defaultArg(map((_arg_1) => _arg_1.Email, customer_1.Responsible), "");
            const serviceResp = defaultArg(map((_arg_2) => _arg_2.Email, customer_1.ServiceLead), "");
            if (((noTerm ? true : contains(int32ToString(customer_1.Number))) ? true : contains(customer_1.Name)) ? true : contains(customerResp)) {
                return true;
            }
            else {
                return contains(serviceResp);
            }
        }
        else {
            return false;
        }
    }));
    const customerCount = sorted.length | 0;
    const rowsToSkip = (page * rowsPerPage) | 0;
    const rowsToTake = ((customerCount < (rowsToSkip + rowsPerPage)) ? (customerCount - rowsToSkip) : rowsPerPage) | 0;
    const accountOption = (a, onAssign, onRevoke) => {
        let elements;
        return MuiHelpers_createElement(TableCell, [["style", {
            textAlign: "center",
        }], ["variant", "body"], ["size", "small"], (elements = toList(delay(() => {
            let child_1, child, props_1;
            if (a != null) {
                const a$0027 = a;
                return append(singleton((child_1 = createElement("span", {
                    style: {
                        cursor: "pointer",
                        userSelect: "none",
                    },
                    onClick: onAssign,
                    children: a$0027.Email,
                }), wrapTooltip(ctx.Locale.t("Edit"), child_1))), delay(() => {
                    let child_2, props_5;
                    return singleton((child_2 = MuiHelpers_createElement(IconButton, [["size", "small"], ["children", (props_5 = {}, react.createElement(Remove, props_5))], ["onClick", onRevoke]]), wrapTooltip(ctx.Locale.t("Revoke"), child_2)));
                }));
            }
            else {
                return singleton((child = MuiHelpers_createElement(IconButton, [["size", "small"], ["children", (props_1 = {}, react.createElement(Add, props_1))], ["onClick", onAssign]]), wrapTooltip(ctx.Locale.t("Add"), child)));
            }
        })), ["children", reactApi.Children.toArray(Array.from(elements))])]);
    };
    const iconCell = (s) => {
        let elems_1;
        return MuiHelpers_createElement(TableCell, [["size", "small"], ["style", {
            color: "hsl(207.3, 30.8%, 21%)",
            textAlign: "center",
            width: 30,
        }], (elems_1 = toList(delay(() => {
            let props_9, props_11;
            return s ? singleton((props_9 = {}, react.createElement(CheckCircle, props_9))) : singleton((props_11 = {}, react.createElement(RemoveCircle, props_11)));
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]);
    };
    const longNameCell = (maxWidth, name_2) => MuiHelpers_createElement(TableCell, [["title", name_2], ["variant", "head"], ["sx", {
        maxWidth: maxWidth,
    }], ["children", MuiHelpers_createElement(Typography, [["noWrap", true], ["children", name_2]])]]);
    const th = (key_30, children_4) => sortHeaderCell(asc, key_30, sortKey, (newSortKey) => {
        patternInput_3[1](!asc);
        patternInput_4[1](newSortKey);
    }, children_4);
    const xs_6 = toList(delay(() => append(singleton(createElement(SnackError, {
        errMsg: unwrap(model_1.ErrorMsg),
        dismiss: () => {
            dispatch(new Message(13, []));
        },
    })), delay(() => append(singleton(createElement(CustomerForm, {
        key: "admin-customer-add-form",
        $key: "admin-customer-add-form",
        isOpen: model_1.AddForm,
        selectedGroupIds: model_1.SelectedGroupIds,
        groups: groupsWithMembers,
        onClose: (newCustomerOpt) => {
            if (newCustomerOpt != null) {
                hierarchyDispatch(new Message_1(0, [newCustomerOpt]));
            }
            dispatch(new Message(2, [false]));
        },
    })), delay(() => {
        let $keyZ666A7A6E, arg_2;
        return append(singleton(($keyZ666A7A6E = ((arg_2 = (defaultArg(map((_arg_5) => _arg_5.Id, model_1.EditForm), 0) | 0), toText(printf("admin-customer-%i-edit-form"))(arg_2))), createElement(CustomerForm, {
            key: $keyZ666A7A6E,
            $key: $keyZ666A7A6E,
            isOpen: model_1.EditForm != null,
            selectedGroupIds: model_1.SelectedGroupIds,
            groups: groupsWithMembers,
            updating: unwrap(model_1.EditForm),
            onClose: (customerOpt) => {
                if (customerOpt != null) {
                    hierarchyDispatch(new Message_1(10, [customerOpt]));
                }
                dispatch(new Message(3, [undefined]));
            },
        }))), delay(() => {
            let matchValue, customerId_4;
            return append((matchValue = model_1.ResponsibleForm, (matchValue != null) ? ((customerId_4 = (matchValue | 0), singleton(createElement(AssignForm, {
                targetId: customerId_4,
                target: new AssignTarget(0, []),
                onClose: (assignedOpt) => {
                    if (assignedOpt != null) {
                        const customer_3 = pick((customer_2) => {
                            if (customer_2.Id === customerId_4) {
                                return new CustomerInfo(customer_2.Id, customer_2.Number, customer_2.Name, customer_2.Enabled, customer_2.EnableServices, customer_2.EnableExtra, customer_2.HasAgreement, customer_2.Favorite, customer_2.Memo, assignedOpt, customer_2.ServiceLead, customer_2.Machines, customer_2.MarketCategories, customer_2.Groups);
                            }
                            else {
                                return undefined;
                            }
                        }, customers);
                        console.debug("[Admin] Found customer: %o", customer_3);
                        hierarchyDispatch(new Message_1(10, [customer_3]));
                    }
                    dispatch(new Message(7, [undefined]));
                },
            })))) : (empty_1())), delay(() => {
                let matchValue_1, customerId_5;
                return append((matchValue_1 = model_1.ServiceLeadForm, (matchValue_1 != null) ? ((customerId_5 = (matchValue_1 | 0), singleton(createElement(AssignForm, {
                    targetId: customerId_5,
                    target: new AssignTarget(2, []),
                    onClose: (accountOpt) => {
                        if (accountOpt != null) {
                            hierarchyDispatch(new Message_1(10, [pick((customer_4) => {
                                if (customer_4.Id === customerId_5) {
                                    return new CustomerInfo(customer_4.Id, customer_4.Number, customer_4.Name, customer_4.Enabled, customer_4.EnableServices, customer_4.EnableExtra, customer_4.HasAgreement, customer_4.Favorite, customer_4.Memo, customer_4.Responsible, accountOpt, customer_4.Machines, customer_4.MarketCategories, customer_4.Groups);
                                }
                                else {
                                    return undefined;
                                }
                            }, customers)]));
                        }
                        dispatch(new Message(10, [undefined]));
                    },
                })))) : (empty_1())), delay(() => {
                    let matchValue_2, customerId_6;
                    return append((matchValue_2 = model_1.RemoveResponsibleForm, (matchValue_2 != null) ? ((customerId_6 = (matchValue_2 | 0), singleton(createElement(RevokeForm, {
                        customerId: customerId_6,
                        target: new AssignTarget(0, []),
                        onClose: (remove) => {
                            if (remove) {
                                hierarchyDispatch(new Message_1(10, [pick((customer_5) => {
                                    if (customer_5.Id === customerId_6) {
                                        return new CustomerInfo(customer_5.Id, customer_5.Number, customer_5.Name, customer_5.Enabled, customer_5.EnableServices, customer_5.EnableExtra, customer_5.HasAgreement, customer_5.Favorite, customer_5.Memo, undefined, customer_5.ServiceLead, customer_5.Machines, customer_5.MarketCategories, customer_5.Groups);
                                    }
                                    else {
                                        return undefined;
                                    }
                                }, customers)]));
                            }
                            dispatch(new Message(5, [undefined]));
                        },
                    })))) : (empty_1())), delay(() => {
                        let matchValue_3, customerId_7;
                        return append((matchValue_3 = model_1.RemoveServiceLeadForm, (matchValue_3 != null) ? ((customerId_7 = (matchValue_3 | 0), singleton(createElement(RevokeForm, {
                            customerId: customerId_7,
                            target: new AssignTarget(2, []),
                            onClose: (remove_1) => {
                                if (remove_1) {
                                    hierarchyDispatch(new Message_1(10, [pick((customer_7) => {
                                        if (customer_7.Id === customerId_7) {
                                            return new CustomerInfo(customer_7.Id, customer_7.Number, customer_7.Name, customer_7.Enabled, customer_7.EnableServices, customer_7.EnableExtra, customer_7.HasAgreement, customer_7.Favorite, customer_7.Memo, customer_7.Responsible, undefined, customer_7.Machines, customer_7.MarketCategories, customer_7.Groups);
                                        }
                                        else {
                                            return undefined;
                                        }
                                    }, customers)]));
                                }
                                dispatch(new Message(6, [undefined]));
                            },
                        })))) : (empty_1())), delay(() => {
                            let matchValue_4, groupId_6, groupId_1;
                            return append((matchValue_4 = tryExactlyOne(model_1.SelectedGroupIds), (matchValue_4 != null) ? ((groupId_6 = (matchValue_4 | 0), append(model_1.ResponsibleGroupForm ? singleton(createElement(AssignForm, {
                                targetId: groupId_6,
                                target: new AssignTarget(1, []),
                                onClose: (groupId_1 = (groupId_6 | 0), (accountOpt_1) => {
                                    customers.forEach((customer_8) => {
                                        if (customer_8.Groups.some((group_2) => (group_2.Id === groupId_1))) {
                                            console.debug("[Admin] Setting %o as responsible for customer %o in group %d", accountOpt_1, customer_8, groupId_1);
                                            hierarchyDispatch(new Message_1(10, [new CustomerInfo(customer_8.Id, customer_8.Number, customer_8.Name, customer_8.Enabled, customer_8.EnableServices, customer_8.EnableExtra, customer_8.HasAgreement, customer_8.Favorite, customer_8.Memo, accountOpt_1, customer_8.ServiceLead, customer_8.Machines, customer_8.MarketCategories, customer_8.Groups)]));
                                        }
                                    });
                                    dispatch(new Message(8, [false]));
                                }),
                            })) : empty_1(), delay(() => {
                                let groupId_2;
                                return append(model_1.ServiceLeadGroupForm ? singleton(createElement(AssignForm, {
                                    targetId: groupId_6,
                                    target: new AssignTarget(3, []),
                                    onClose: (groupId_2 = (groupId_6 | 0), (accountOpt_2) => {
                                        customers.forEach((customer_9) => {
                                            if (customer_9.Groups.some((group_3) => (group_3.Id === groupId_2))) {
                                                console.debug("[Admin] Setting %o as service lead for %o in group %d", accountOpt_2, customer_9, groupId_2);
                                                hierarchyDispatch(new Message_1(10, [new CustomerInfo(customer_9.Id, customer_9.Number, customer_9.Name, customer_9.Enabled, customer_9.EnableServices, customer_9.EnableExtra, customer_9.HasAgreement, customer_9.Favorite, customer_9.Memo, customer_9.Responsible, accountOpt_2, customer_9.Machines, customer_9.MarketCategories, customer_9.Groups)]));
                                            }
                                        });
                                        dispatch(new Message(11, [false]));
                                    }),
                                })) : empty_1(), delay(() => append(model_1.ResponsibleReplaceForm ? singleton(createElement(ReplaceForm, {
                                    groupId: groupId_6,
                                    target: new AssignTarget(0, []),
                                    onClose: (replaceOpt) => {
                                        if (replaceOpt != null) {
                                            const patternInput_7 = value_189(replaceOpt);
                                            const replaced = patternInput_7[0];
                                            const assigned = patternInput_7[1];
                                            customers.forEach((customer_10) => {
                                                if (customer_10.Groups.some((group_4) => (group_4.Id === groupId_6))) {
                                                    const newRespOpt = map((current) => {
                                                        if (current.AccountId === replaced.AccountId) {
                                                            return assigned;
                                                        }
                                                        else {
                                                            return current;
                                                        }
                                                    }, customer_10.Responsible);
                                                    console.debug("[Admin] Replaced customer %o responsible %o with %o", customer_10, replaced, assigned);
                                                    hierarchyDispatch(new Message_1(10, [new CustomerInfo(customer_10.Id, customer_10.Number, customer_10.Name, customer_10.Enabled, customer_10.EnableServices, customer_10.EnableExtra, customer_10.HasAgreement, customer_10.Favorite, customer_10.Memo, newRespOpt, customer_10.ServiceLead, customer_10.Machines, customer_10.MarketCategories, customer_10.Groups)]));
                                                }
                                            });
                                        }
                                        dispatch(new Message(9, [false]));
                                    },
                                })) : empty_1(), delay(() => {
                                    let groupId_4;
                                    return append(model_1.ServiceLeadReplaceForm ? singleton(createElement(ReplaceForm, {
                                        groupId: groupId_6,
                                        target: new AssignTarget(2, []),
                                        onClose: (groupId_4 = (groupId_6 | 0), (replaceOpt_1) => {
                                            console.debug("[Admin] Replacing service lead %o for all customers in group %i", replaceOpt_1, groupId_4);
                                            if (replaceOpt_1 != null) {
                                                const patternInput_8 = value_189(replaceOpt_1);
                                                customers.forEach((customer_11) => {
                                                    if (customer_11.Groups.some((group_5) => (group_5.Id === groupId_4))) {
                                                        hierarchyDispatch(new Message_1(10, [new CustomerInfo(customer_11.Id, customer_11.Number, customer_11.Name, customer_11.Enabled, customer_11.EnableServices, customer_11.EnableExtra, customer_11.HasAgreement, customer_11.Favorite, customer_11.Memo, customer_11.Responsible, map((current_1) => {
                                                            if (current_1.AccountId === patternInput_8[0].AccountId) {
                                                                return patternInput_8[1];
                                                            }
                                                            else {
                                                                return current_1;
                                                            }
                                                        }, customer_11.ServiceLead), customer_11.Machines, customer_11.MarketCategories, customer_11.Groups)]));
                                                    }
                                                });
                                            }
                                            dispatch(new Message(12, [false]));
                                        }),
                                    })) : empty_1(), delay(() => {
                                        let matchValue_5;
                                        return append((matchValue_5 = model_1.PreForm, (matchValue_5 != null) ? singleton(preMultiWarning(ctx.Locale, matchValue_5, dispatch)) : (empty_1())), delay(() => {
                                            let groupId_5;
                                            return model_1.MultiCategoryForm ? singleton(createElement(MultiAssignCategoryForm, {
                                                groupId: groupId_6,
                                                onClose: (groupId_5 = (groupId_6 | 0), (categoryOpt) => {
                                                    console.debug("[Admin] Market category %o for all customers in group %i", categoryOpt, groupId_5);
                                                    if (categoryOpt != null) {
                                                        const category = value_189(categoryOpt);
                                                        customers.forEach((customer_12) => {
                                                            if (customer_12.Groups.some((group_6) => (group_6.Id === groupId_5))) {
                                                                hierarchyDispatch(new Message_1(10, [new CustomerInfo(customer_12.Id, customer_12.Number, customer_12.Name, customer_12.Enabled, customer_12.EnableServices, customer_12.EnableExtra, customer_12.HasAgreement, customer_12.Favorite, customer_12.Memo, customer_12.Responsible, customer_12.ServiceLead, customer_12.Machines, append_1(customer_12.MarketCategories, [category]), customer_12.Groups)]));
                                                            }
                                                        });
                                                    }
                                                    dispatch(new Message(4, [false]));
                                                }),
                                            })) : empty_1();
                                        }));
                                    }));
                                }))));
                            })))) : (empty_1())), delay(() => {
                                let elems_13, elems_4, elems_3, elems_2, elements_7, elements_6, children_12, children_11, child_3, props_26, child_4, props_29, child_5, props_32, child_6, props_35, child_7, props_38, child_8, children_14;
                                return singleton(createElement("div", createObj(ofArray([["style", {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 30 + "px",
                                    width: 100 + "%",
                                    height: 100 + "%",
                                }], (elems_13 = [createElement("div", createObj(ofArray([["style", {
                                    display: "flex",
                                    width: 100 + "%",
                                    paddingTop: 5 + "px",
                                }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    flexGrow: 1,
                                    gap: 16 + "px",
                                }], (elems_3 = [createElement("div", createObj(ofArray([["style", {
                                    minWidth: 24 + "ch",
                                }], (elems_2 = [createElement(Components_CustomerGroupSelect_Z6A6DEF5D, {
                                    key: "admin-customer-group-select",
                                    $key: "admin-customer-group-select",
                                    onChange: (groups_1) => {
                                        const groupIds = map_2((_arg_3) => _arg_3.Id, groups_1, Int32Array);
                                        const groupIdStrs = join(",", map_2(int32ToString, groupIds));
                                        setPage(0);
                                        dispatch(new Message(0, [groupIds]));
                                        console.debug("groupIdStrs", groupIdStrs);
                                        if (groups_1.length === 0) {
                                            removeQuery("groups");
                                        }
                                        else {
                                            setQuery("groups", groupIdStrs);
                                        }
                                    },
                                    selected: model_1.SelectedGroupIds,
                                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", {
                                    style: {
                                        flexBasis: 320 + "px",
                                    },
                                    children: createElement(Components_Searchbar_25F45B5E, {
                                        placeholder: ctx.Locale.t("CustomerAdmin.SearchForCustomers"),
                                        onChange: (ev) => {
                                            patternInput_2[1](ev.target.value);
                                        },
                                    }),
                                }), MuiHelpers_createElement(FormControlLabel, [["label", ctx.Locale.t("UserAdmin.ShowInactive")], ["labelPlacement", "end"], ["control", MuiHelpers_createElement(Switch, [["color", "primary"], ["checked", showInactive], ["onChange", (e) => {
                                    patternInput_1[1](e.target.checked);
                                }]])]])], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement(Components_Button_Z1043B8E, {
                                    text: ctx.Locale.t("CustomerAdmin.Add"),
                                    onClick: (_arg_6) => {
                                        dispatch(new Message(2, [!model_1.AddForm]));
                                    },
                                    startIcon: (props_21) => {
                                        const props_23 = createObj(props_21);
                                        return react.createElement(Add, props_23);
                                    },
                                })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), MuiHelpers_createElement(TableContainer, [["sx", {
                                    flexGrow: 1,
                                }], (elements_7 = [MuiHelpers_createElement(Table, [["size", "small"], (elements_6 = [(children_12 = singleton_1((children_11 = ofArray([th("Number", [ctx.Locale.t("Customer.CustomerNo")]), th("Name", [ctx.Locale.t("Customer.Name")]), th("Groups", ["Kundegrupper"]), th("Responsible", [ctx.Locale.t("CustomerAdmin.CustomerResponsible"), (child_3 = MuiHelpers_createElement(IconButton, [["style", {
                                    margin: ((((((0 + "px ") + 5) + "px ") + 0) + "px ") + 5) + "px",
                                }], ["size", "small"], ["disabled", model_1.SelectedGroupIds.length !== 1], ["children", (props_26 = {}, react.createElement(PersonAddOutlined, props_26))], ["onClick", (ev_1) => {
                                    ev_1.stopPropagation();
                                    ev_1.preventDefault();
                                    dispatch(new Message(1, [new PreMultiForm(0, [])]));
                                }]]), disabledTooltip(ctx.Locale.t("CustomerAdmin.AssignFullGroup"), child_3)), (child_4 = MuiHelpers_createElement(IconButton, [["style", {
                                    margin: ((((((0 + "px ") + 5) + "px ") + 0) + "px ") + 5) + "px",
                                }], ["size", "small"], ["disabled", model_1.SelectedGroupIds.length !== 1], ["children", (props_29 = {}, react.createElement(SyncAlt, props_29))], ["onClick", (ev_2) => {
                                    ev_2.stopPropagation();
                                    ev_2.preventDefault();
                                    dispatch(new Message(1, [new PreMultiForm(1, [])]));
                                }]]), disabledTooltip(ctx.Locale.t("CustomerAdmin.SwitchAssign"), child_4))]), th("ServiceLead", [ctx.Locale.t("CustomerAdmin.ServiceLead"), (child_5 = MuiHelpers_createElement(IconButton, [["style", {
                                    margin: ((((((0 + "px ") + 5) + "px ") + 0) + "px ") + 5) + "px",
                                }], ["size", "small"], ["disabled", model_1.SelectedGroupIds.length !== 1], ["children", (props_32 = {}, react.createElement(PersonAddOutlined, props_32))], ["onClick", (ev_3) => {
                                    ev_3.stopPropagation();
                                    ev_3.preventDefault();
                                    dispatch(new Message(1, [new PreMultiForm(2, [])]));
                                }]]), disabledTooltip(ctx.Locale.t("CustomerAdmin.AssignFullGroup"), child_5)), (child_6 = MuiHelpers_createElement(IconButton, [["style", {
                                    margin: ((((((0 + "px ") + 5) + "px ") + 0) + "px ") + 5) + "px",
                                }], ["size", "small"], ["disabled", model_1.SelectedGroupIds.length !== 1], ["children", (props_35 = {}, react.createElement(SyncAlt, props_35))], ["onClick", (ev_4) => {
                                    ev_4.stopPropagation();
                                    ev_4.preventDefault();
                                    dispatch(new Message(1, [new PreMultiForm(3, [])]));
                                }]]), disabledTooltip(ctx.Locale.t("CustomerAdmin.SwitchAssign"), child_6))]), th("MarketCategories", [ctx.Locale.t("CustomerAdmin.MarketCategory"), (child_7 = MuiHelpers_createElement(IconButton, [["style", {
                                    margin: ((((((0 + "px ") + 5) + "px ") + 0) + "px ") + 5) + "px",
                                }], ["size", "small"], ["children", (props_38 = {}, react.createElement(AddOutlined, props_38))], ["onClick", (ev_5) => {
                                    ev_5.stopPropagation();
                                    ev_5.preventDefault();
                                    dispatch(new Message(1, [new PreMultiForm(4, [])]));
                                }]]), wrapTooltip(ctx.Locale.t("CustomerAdmin.AddCategoryAll"), child_7))]), th("EnableExtra", ["Ekstra"]), th("EnableServices", [(child_8 = ctx.Locale.t("CustomerAdmin.ActivityPlan"), wrapTooltip(ctx.Locale.t("Services.ServicePlan"), child_8))]), th("Enabled", [ctx.Locale.t("Active")]), MuiHelpers_createElement(TableCell, [["style", {
                                    textAlign: "left",
                                }], ["variant", "head"], ["size", "small"]])]), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_11))]]))), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_12))]])), (children_14 = singleton_1(map_2((customer_13) => {
                                    let elems_9, elements_3, elements_4, child_9, props_44;
                                    return MuiHelpers_createElement(TableRow, [(elems_9 = [MuiHelpers_createElement(TableCell, [["children", int32ToString(customer_13.Number)]]), longNameCell(30 + "ch", customer_13.Name), MuiHelpers_createElement(TableCell, [["size", "small"], (elements_3 = map_2((group_7) => MuiHelpers_createElement(Chip, [["size", "small"], ["label", group_7.Name], ["style", {
                                        margin: ((((((0 + "px ") + 3) + "px ") + 3) + "px ") + 0) + "px",
                                    }]]), customer_13.Groups), ["children", reactApi.Children.toArray(Array.from(elements_3))])]), accountOption(customer_13.Responsible, (_arg_7) => {
                                        dispatch(new Message(7, [customer_13.Id]));
                                    }, (_arg_8) => {
                                        dispatch(new Message(5, [customer_13.Id]));
                                    }), accountOption(customer_13.ServiceLead, (_arg_9) => {
                                        dispatch(new Message(10, [customer_13.Id]));
                                    }, (_arg_10) => {
                                        dispatch(new Message(6, [customer_13.Id]));
                                    }), longNameCell(20 + "ch", join(", ", map_2((m) => {
                                        if (equals(ctx.Language, new Localization_Language(1, []))) {
                                            return m.NameEn;
                                        }
                                        else {
                                            return m.NameNo;
                                        }
                                    }, customer_13.MarketCategories))), iconCell(customer_13.EnableExtra), iconCell(customer_13.EnableServices), iconCell(customer_13.Enabled), MuiHelpers_createElement(TableCell, [["style", {
                                        textAlign: "center",
                                        width: 25,
                                    }], (elements_4 = [(child_9 = MuiHelpers_createElement(IconButton, [["onClick", (_arg_11) => {
                                        dispatch(new Message(3, [customer_13]));
                                    }], ["size", "small"], ["children", (props_44 = {}, react.createElement(Edit, props_44))]]), wrapTooltip(ctx.Locale.t("Edit"), child_9))], ["children", reactApi.Children.toArray(Array.from(elements_4))])])], ["children", reactApi.Children.toArray(Array.from(elems_9))])]);
                                }, sorted.slice(rowsToSkip, (rowsToSkip + rowsToTake) + 1))), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_14))]]))], ["children", reactApi.Children.toArray(Array.from(elements_6))])])], ["children", reactApi.Children.toArray(Array.from(elements_7))])]), MuiHelpers_createElement(TablePagination, [["component", "div"], ["sx", {
                                    flexShrink: 0,
                                }], ["count", sorted.length], ["page", page], ["rowsPerPage", rowsPerPage], ["onPageChange", ((arg10$0040, newPage) => {
                                    onPageChange(setPage, arg10$0040, newPage);
                                })], ["onRowsPerPageChange", (ev_6) => {
                                    const newRowsPerPage = ev_6.target.value | 0;
                                    setPage(0);
                                    patternInput_6[1](newRowsPerPage);
                                }]])], ["children", reactApi.Children.toArray(Array.from(elems_13))])]))));
                            }));
                        }));
                    }));
                }));
            }));
        }));
    }))))));
    return react.createElement(react.Fragment, {}, ...xs_6);
}

export function View() {
    let elems_1, elements, elems_3, elems_2;
    const hierarchy = reactApi.useContext(hierarchyContext);
    const currentUrl = RouterModule_urlSegments(window.location.hash, 1);
    const groups = map_2((group) => (new CustomerGroup(group.Id, group.Name, group.Enabled, group.IsMain, group.IsPtg, group.Company)), hierarchy.Groups);
    let page;
    let matchResult, _rest;
    if (!isEmpty(currentUrl)) {
        if (head(currentUrl) === "admin") {
            if (!isEmpty(tail(currentUrl))) {
                if (head(tail(currentUrl)) === "customer-groups") {
                    if (isEmpty(tail(tail(currentUrl)))) {
                        matchResult = 1;
                    }
                    else if (head(tail(tail(currentUrl))) === "customers") {
                        matchResult = 0;
                        _rest = tail(tail(tail(currentUrl)));
                    }
                    else {
                        matchResult = 2;
                    }
                }
                else {
                    matchResult = 2;
                }
            }
            else {
                matchResult = 2;
            }
        }
        else {
            matchResult = 2;
        }
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0: {
            page = 2;
            break;
        }
        case 1: {
            page = 1;
            break;
        }
        default:
            throw new Error("todo: admin customers navigation");
    }
    const dependencies = [hierarchy.Groups];
    reactApi.useEffect(() => {
        console.info(some("[Admin] Hierarchy groups changed! %o"), hierarchy.Groups);
    }, dependencies);
    const xs_5 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 10 + "px",
    }], (elems_1 = [MuiHelpers_createElement(Typography, [["variant", "h1"], ["children", "Kunder"]]), MuiHelpers_createElement(Tabs, [["style", {
        paddingBottom: 10 + "px",
    }], ["value", page], ["onChange", (_arg, v) => {
        const newValue = v | 0;
        console.debug("New tab", newValue);
        switch (newValue) {
            case 1: {
                RouterModule_nav(ofArray(["admin", "customer-groups"]), 1, 1);
                break;
            }
            case 2: {
                RouterModule_nav(ofArray(["admin", "customer-groups", "customers"]), 1, 1);
                break;
            }
            default:
                throw new Error("todo: admin customers handleChange");
        }
    }], (elements = [MuiHelpers_createElement(Tab, [["value", 1], ["label", "Kundegrupper"]]), MuiHelpers_createElement(Tab, [["value", 2], ["label", "Kunder"]])], ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["className", join(" ", ["rounded-container"])], ["style", {
        width: 100 + "%",
        height: ("calc(" + "100vh - 120px - 30px - 140px - 30px") + ")",
    }], (elems_3 = [createElement("div", createObj(ofArray([["className", join(" ", ["main-tab-container-inner"])], ["style", {
        width: 100 + "%",
    }], (elems_2 = toList(delay(() => ((page === 1) ? singleton(createElement(CustomerGroupAdmin, {
        groups: groups,
    })) : ((page === 2) ? singleton(createElement(CustomerAdmin, {
        groupsWithMembers: hierarchy.Groups,
    })) : singleton(createElement("p", {
        children: ["404"],
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))];
    return react.createElement(react.Fragment, {}, ...xs_5);
}

